import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-xiangdao",
  "use": "icon-xiangdao-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-xiangdao\"><path fill=\"#515151\" d=\"M950.857143 134.095238v763.233524H73.142857v-76.324572h585.142857V210.407619H73.142857V134.095238h877.714286z m-73.142857 69.388191H731.428571v624.457142h146.285715V203.483429z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol